export const GETANNEXOVERVIEW = {
  REQUEST: 'GridSelections/GetAnnexOverview/Request',
  SUCCESS: 'GridSelections/GetAnnexOverview/Success',
  FAILURE: 'GridSelections/GetAnnexOverview/Failure'
};
export const GETREQUESTEDSERVICES = {
  REQUEST: 'GridSelections/GetRequestedServices/Request',
  SUCCESS: 'GridSelections/GetRequestedServices/Success',
  FAILURE: 'GridSelections/GetRequestedServices/Failure'
};
export const GETPARTYGRID = {
  REQUEST: 'GridSelections/GetPartyGrid/Request',
  SUCCESS: 'GridSelections/GetPartyGrid/Success',
  FAILURE: 'GridSelections/GetPartyGrid/Failure'
};
export const GETUSERGRID = {
  REQUEST: 'GridSelections/GetUserGrid/Request',
  SUCCESS: 'GridSelections/GetUserGrid/Success',
  FAILURE: 'GridSelections/GetUserGrid/Failure'
};
export const GETEXERCISEGRID = {
  REQUEST: 'GridSelections/GetExerciseGrid/Request',
  SUCCESS: 'GridSelections/GetExerciseGrid/Success',
  FAILURE: 'GridSelections/GetExerciseGrid/Failure'
};
export const GETSORGRID = {
  REQUEST: 'GridSelections/GetSorGrid/Request',
  SUCCESS: 'GridSelections/GetSorGrid/Success',
  FAILURE: 'GridSelections/GetSorGrid/Failure'
};
export const GETAUDITLOGGRID = {
  REQUEST: 'GridSelections/GetAuditLogGrid/Request',
  SUCCESS: 'GridSelections/GetAuditLogGrid/Success',
  FAILURE: 'GridSelections/GetAuditLogGrid/Failure'
};
export const GET_CATALOG_GRID = {
  REQUEST: 'GridSelections/GetCatalogGrid/Request',
  SUCCESS: 'GridSelections/GetCatalogGrid/Success',
  FAILURE: 'GridSelections/GetCatalogGrid/Failure'
};
export const GET_ORDER_GRID = {
  REQUEST: 'GridSelections/GetOrderGrid/Request',
  SUCCESS: 'GridSelections/GetOrderGrid/Success',
  FAILURE: 'GridSelections/GetOrderGrid/Failure'
};
export const GET_GROUP_GRID = {
  REQUEST: 'GridSelections/GetGroupGrid/Request',
  SUCCESS: 'GridSelections/GetGroupGrid/Success',
  FAILURE: 'GridSelections/GetGroupGrid/Failure'
};
export const GET_TICKET_GRID = {
  REQUEST: 'GridSelections/GetTicketGrid/Request',
  SUCCESS: 'GridSelections/GetTicketGrid/Success',
  FAILURE: 'GridSelections/GetTicketGrid/Failure'
};
export const GET_ACTIVITY_GRID = {
  REQUEST: 'GridSelections/GetActivityGrid/Request',
  SUCCESS: 'GridSelections/GetActivityGrid/Success',
  FAILURE: 'GridSelections/GetActivityGrid/Failure'
};


